import HelpListComponent from '../helpListComponent/helpListComponent';
import HeroHelpPage from '../heroHelpPage/heroHelpPage';

export default function HelpPage() {


  return (
      <>
        <HeroHelpPage/>
        <HelpListComponent/>
      </>
  )
}